export default {
  contractAgency: {
    button: {
      addClientBtn: '创建代理合同',
      editClientBtn: '修改代理合同',
    },
    dismissReason: '驳回原因',
    RMB: '人民币',
    listTitle: '代理合同总览',
    baseTitle: '基本信息',
    index: '序号',
    externalContractNo: '外部合同号',
    contractNo: '合同编号',
    contractNoHN: '订单编号',
    tradeType: '贸易类型',
    tradeTypeHN: '贸易类型',
    contractDetailCategoryHN: '订单类型',
    businessNature: '业务性质',
    businessNatureHN: '经营方式',
    orderMakeTime: '制单日期',
    signDateHN: '签约日期',
    signDateStartHN: '签约日期从',
    signDateEndHN: '签约日期到',
    businessDepartment: '业务部门',
    saleMan: '业务员',
    company: '公司',
    companyName: '公司名称',
    productDesc: '商品描述',
    productDescHN: '商品描述',
    contractNumber: '合同数量（吨）',
    contractNumberHN: '签约数量',
    receiptStatus: '单据状态',
    receiptStatusHN: '订单状态',
    warehouse: '仓库',
    supplier: '供应商',
    validateSupplier: '请选择供应商',
    partnerZhName: '合作伙伴名称',
    partnerCode: '合作伙伴编码',
    customer: '客户',
    validateCustomer: '请选择客户',
    payWay: '付款方式',
    priceTypeHN: '单价类型',
    getPayWay: '采购付款方式',
    sellPayWay: '销售付款方式',
    contractPrice: '合同单价',
    contractPriceHN: '单价',
    payTimeLate: '最晚付款日',
    getGoodLate: '最晚收货日',
    getGoodWay: '收货方式',
    transportWay: '运输方式',
    clientName: '委托方',
    clientNameHN: '签约客户',
    receiveTimeLate: '最晚收款日',
    shipLate: '最晚发货日',
    shipWap: '交货方式',
    agencyFee: '代理费',
    agencyFeeSearch: '代理费',
    depositCash: '保证金',
    depositCashSearch: '保证金',
    marginAmountHN: '保证金',
    businessId: '业务订单',
    oprateMan: '操作人',
    settlement: '结算货币',
    settlementHN: '货币',
    purchaseText: '采购端',
    salesText: '代理端',
    salesTextHN: '销售端',
    purchaseExternalContractNo: '外部合同号 (采购端)',
    purchasePayMethod: '采购付款方式',
    purchasePriceTypeHN: '采购单价类型',
    purchaseCurrency: '采购货币',
    purchaseExpense: '采购费用',
    salesExternalContractNo: '外部合同号 (代理端)',
    salesPayMethod: '销售付款方式',
    salesPriceTypeHN: '销售单价类型',
    salesCurrency: '销售货币',
    salesExpense: '销售费用',
    proxyType: '代理形式',
    agentPurchasing: '代理采购',
    salesAgent: '代理销售',
    thirdPartyAgent: '第三方代理',
    capitalOccupancyRate: '资金占用利率',
    interestRateHN: '利率水平',
    overShippedPercentage: '溢装比例',
    shortShippedPercentage: '短装比例',
    marginPercentage: '保证金比率',
    marginPercentageHN: '保证金比率(%)',
    inportCountry: '进口国别',
    originPlace: '原产地',
    lastestReceiveProductDay: '最晚收货日 (采购端)',
    lastestPayMoneyDay: '最晚付款日 (采购端)',
    lastestSendProductDay: '最晚发货日 (代理端)',
    lastestReceiveMoneyDay: '最晚收款日 (代理端)',
    expectReceiptDay: '预计收款日期',
    isInsure: '投保',
    fileTitle: '附件上传',
    inputTip: '请输入',
    selectTip: '请选择',
    rateLabel: '汇率',
    contractCurrencyExchangeRate: '采购汇率',
    salesCurrencyExchangeRate: '销售汇率',
    rateMessage: '汇率不能为空',
    mark: '备注',
    isPriceDifferenceOrder: '差价订单',
    isContractOrder: '合约订单',

    performancePeriodHN: '履约期',
    latestPerformanceDateHN: '最晚履约期',
    creditInterestRateHN: '赊销利率水平',
    supplierContactPersonHN: '供应商联系人',
    supplierContactTelHN: '联系方式',
    customerContactPersonHN: '客户联系人',
    customerContactTelHN: '联系方式',
    paymentTimesHN: '全额一次性支付',
    shippedQuantityHN: '销售发货数量',
    adjustedMarginAmountHN: '保证金金额(调整后)',
    isCreditsaleHN: '是否赊销',
    prepayAmountHN: '预付金额',
    auto: '自动生成',
    productTab: {
      title: '产品明细',
      titleHN: '明细信息',
      addBtn: '创建',
      deleteBtn: '删除',
      index: '序号',
      productDesc: '商品描述',
      productNo: '商品编码',
      productNoPlaceholder: '请选择商品编码',
      contractQuantity: '合同数量',
      contractQuantityHN: '签约数量',
      contractQuantityHNPlaceholder: '请输入签约数量',
      unit: '单位',
      unitHN: '计量单位',
      warehouse: '仓库',
      purchaseTitle: '采购端',
      businessTotalAmount: '价税合计金额',
      businessTaxAmount: '税额',
      businessPureAmount: '净值',
      proxyBusinessTitle: '代理端',
      originCoin: '原币',
      localCoin: '本币',
      purchaseOriginCoin: '采购合同价格(原币)',
      purchaseLocalCoin: '采购合同价格(本币)',
      proxyOriginCoin: '代理合同价格(原币)',
      proxyLocalCoin: '代理合同价格(本币)',
      totalText: '小计',
      emptyTip: '不能为空',
      shippingUnitExpenseHN: '运费单价',
      purchaseBusinessUnitPriceHN: '采购单价',
      purchaseBusinessUnitPriceHNPlaceholder: '采购单价不能为空(请维护采购货物价格)',
      proxyBusinessUnitPriceHNPlaceholder: '销售单价不能为空(请维护销售货物价格)',
      purchaseBusinessTotalAmountHN: '采购金额',
      proxyBusinessUnitPriceHN: '销售单价',
      proxyBusinessTotalAmountHN: '销售金额',
      businessUnitPriceHN: '订单单价',
      businessTotalAmountHN: '订单金额',
    },
    moneyRateTab: {
      title: '利息计算',
      isInterest: '是否收取利息',
      interestRule: '计息规则',
      startDate: '起息日期',
      overdueDate: '逾期日期',
      interestAmount: '计息金额(原币)',
      interestAmountLocal: '计息金额(本币)',
      marginAmount: '应追加保证金',
      rateFormCol1: '利息档次',
      rateFormCol2: '计息天数',
      rateFormCol3: '月利率',
      overdualDays: '约定日内',
      overdualDays1: '逾期1',
      overdualDays2: '逾期2',
      overdualDays3: '逾期3',
      overdualDays4: '逾期4',
    },
    transportTab: {
      title: '运输信息',
      startAddress: '起运地',
      destinationAddress: '目的地',
      shipAddress: '转运港',
      freightExpense: '运杂费',
      storageExpense: '仓储费',
      outInExpense: '出入库费',
      loadingUnitPrice: '装车费单价',
      deliveryUnitPrice: '运输费单价',
      acceptanceDiscountUnitPrice: '承兑贴息单价',
      lastestShipmentDate: '最迟装船日期',
      lastestDeliveryDate: '最迟收货日期',
      actualShipmentDate: '实际装期',
      otherExpenseComment: '其他费用说明',
      shipmentCondition: '装运条件',
    },
    relationTab: {
      title: '关联明细',
      index: '序号',
      oprate: '操作',
      number: '编号',
      type: '类型',
      createTime: '制单日期',
      identify: '关联标识',
      openButton: '关联合同',
      deleteBtn: '删除',
      dialogTitle: '选择关联合同',
      before: '前置',
      after: '后置',
    },
    errorTips: {
      submitEmptyTip: '请选择已保存和已驳回的单据提交',
      submitStatusTip: '所选单据中存在非已保存状态的单据，请重新选择',
      deleteEmptyTip: '请选择已保存和已驳回合同进行删除',
      deleteStatusTip: '请选择已保存和已驳回合同进行删除',
      copyEmptyTip: '请选择一条已生效的单据复制',
      copyStatusTip: '请选择一条已生效的单据复制',
      columnEmptyTip: '请至少选择一列数据导出',
      nosearchError: '请选择至少一个查询条件',
    },
    opreaionInfo: '操作信息',
    confirmInfo: '确认信息',
    operatorName: '确认人',
    confirmType: '确认状态',
    confirmDate: '确认日期',
  },
};
